<template>
  <!--
      作者 kmdshop
      时间：2020-9-25
      描述：设置-仓库设置
  -->
  <div>
    <!--form表单-->
    <el-form size="small" ref="formData" :model="formData" label-width="150px">
      <!--仓库设置-->
      <div class="common-form">好友圈设置</div>
      <el-form-item label="分享图" :rules="[{required: true,message: '请上传分享图'}]">
        <el-button @click="chooseShareImg">选择图片</el-button>
        <img class="mt10" v-img-url="formData.share_image" width="200">
        <p class="gray">*建议540X240</p>
      </el-form-item>
      <el-form-item label="个人中心好友圈首图" :rules="[{required: true,message: '请上传好友圈首图'}]">
        <el-button @click="chooseImg">选择图片</el-button>
        <img class="mt10" v-img-url="formData.image" width="200">
        <p class="gray">*建议690X220</p>
      </el-form-item>
      <el-form-item label="添加好友首图" :rules="[{required: true,message: '请上传好友首图'}]">
        <el-button @click="chooseImgs">选择图片</el-button>
        <img class="mt10" v-img-url="formData.images" width="200">
        <p class="gray">*建议750X400</p>
      </el-form-item>
      
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
      </div>
    </el-form>

    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc"></Upload>
    <Uploads v-if="isuploads" :isupload="isuploads" :config="{ total: 3 }" @returnImgs="returnImgsFuncs"></Uploads>
    <UploadShare v-if="isuploadShare" :isupload="isuploadShare" :config="{ total: 3 }" @returnImgs="returnShareImgsFunc"></UploadShare>
  </div>
</template>

<script>

  import FriendsApi from '@/api/friends.js';
  import Upload from '@/components/file/Upload';
  import Uploads from '@/components/file/Upload';
  import UploadShare from '@/components/file/Upload';
  export default{
    components:{
      Upload,
      Uploads,
      UploadShare,
    },
    
    data(){
      return {
        /*是否正在加载*/
        loading:true,
        /*表单数据对象*/
        formData:{
          image:'',
          images:'',
          share_image:'',
        },
        /*是否打开图片选择*/
        isupload:false,
        isuploads:false,
        isuploadShare:false,
      }
    },
    created() {
      this.getParams();
    },
    methods:{
      /*获取配置数据*/
      getParams() {
        let self = this;
        FriendsApi.getFriend({}, true).then(res => {
            if (res.code == 1) {
              self.formData=res.data.vars.values;
              self.loading=false;
            } else {
              console.log();
            }
          })
          .catch(error => {

          });
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.formData;
        self.$refs.formData.validate((valid) => {
          if (valid) {
            self.loading = true;
            FriendsApi.setFriend(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你， 设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },
      /*选择图片*/
      chooseImg(){
        this.isupload=true;
      },
      /*选择图片*/
      chooseImgs(){
        this.isuploads=true;
      },

    /*选择图片*/
      chooseShareImg(){
        this.isuploadShare=true;
      },
      /*关闭选择图片*/
      returnImgsFunc(e){
        this.isupload=false;
        this.formData.image=e[0].file_path;
      },

      /*关闭选择图片*/
      returnImgsFuncs(e){
        this.isuploads=false;
        this.formData.images=e[0].file_path;
      },
      /*关闭选择图片*/
      returnShareImgsFunc(e){
        this.isuploadShare=false;
        this.formData.share_image=e[0].file_path;
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/friends/setting.vue